import {
    getRefreshToken,
    removeToken,
    removeRefreshToken,
    setToken,
    setRefreshToken,
} from '../helpers/handleToken';

class RefreshTokenManager {
    constructor() {
        this.isRefreshing = false;
        this.pendingRequests = [];
    }

    addRequest(callback) {
        this.pendingRequests.push(callback);
    }

    resolveRequests(newToken) {
        this.pendingRequests.forEach((callback) => callback(newToken));
        this.pendingRequests = [];
    }

    async refreshAccessToken(apiInstance) {
        if (this.isRefreshing) {
            return new Promise((resolve) => {
                this.addRequest((token) => resolve(token));
            });
        }

        this.isRefreshing = true;

        try {
            const response = await apiInstance.post('/refresh-token', {
                refresh_token: getRefreshToken(),
            });

            const { access_token: accessToken, refresh_token: refreshToken } = response.data;

            setToken(accessToken);
            setRefreshToken(refreshToken);

            this.resolveRequests(accessToken);
            return accessToken;
        } catch (error) {
            removeToken();
            removeRefreshToken();
            window.location.reload();
            return Promise.reject(error);
        } finally {
            this.isRefreshing = false;
        }
    }
}

export default new RefreshTokenManager();
